import Video from "./video"
import Audio from "./audio"

export default class Player {

    static createFromMarkup(el) {
        var data = [];

        function first(target, name) {
            const elements = target.getElementsByClassName(name);
            return (elements.length > 0) ? elements[0] : null;
        }

        function firstProperty(target, name, prop) {
            const element = first(target, name);
            return element ? element[prop] : null;
        }

        function firstAttribute(target, name, attr) {
            const element = first(target, name);
            return element ? element.getAttribute(attr) : null;
        }

        Array.from(el.children, media => {
            var item = {};

            item.title = firstProperty(media, 'media-title', 'innerText');
            item.duration = firstProperty(media, 'media-duration', 'innerText');
            item.transcript = firstProperty(media, 'media-transcript', 'innerHTML');

            if (media.classList.contains('media-video')) {
                item.type = 'video';
                item.poster = firstAttribute(media, 'media-poster', 'src');
                item.mp4src = firstAttribute(media, 'media-link', 'href');
                item.embed = firstProperty(media, 'media-player-embed', 'outerHTML');
            } else if (media.classList.contains('media-audio')) {
                item.type = 'audio';
                item.mp3src = firstAttribute(media, 'media-link', 'href');
            }

            data.push(item);
        });

        const items = data.map(function (item) {
            switch (item.type) {
                case 'video':
                    return new Video(item);
                case 'audio':
                    return new Audio(item);
            }
        });

        return new Player(items);
    }

    constructor(items) {
        this.items = items;
    }

    render() {
        return `
            <div class="media-js">
                <div class="media-js-stage">
                    ${this.items.map(item => `
                        <div data-target="media.player" id="media-${item.id}">
                            ${this.renderPlayer(item)}
                        </div>
                    `).join('')}
                </div>
                <nav class="media-js-playlist" aria-label="Media playlist">
                    <ul>
                        ${this.items.map((item, index) => `
                            <li data-target="media.playlistItem" id="media-${item.id}-playlist-item" class="media-js-item">
                                ${this.renderPlaylistItem(item, index + 1)}
                            </li>
                        `).join('')}
                    </ul>
                </nav>
            </div>
        `;
    }

    renderPlayer(item) {
        switch (item.type) {
            case 'video':
                if (item.embed) {
                    return item.embed;
                }

                return `
                    <video class="media-plyr" poster="${item.poster}" playsinline controls>
                        <source src="${item.mp4src}" type="video/mp4">
                    </video>
                `;
            case 'audio':
                return `
                    <audio class="media-plyr" controls>
                        <source src="${item.mp3src}" type="audio/mp3">
                    </audio>
                `;
        }
    }

    renderPlaylistItem(item, number) {
        const title = `
            <h2 class="media-js-title" aria-describedby="media-${item.id}-duration">
                <a data-action="media#selectItem" data-target="media.selector" href="#media-${item.id}" class="media-js-link">${this.items.length > 1 ? number + '. ' : ''}${item.title}</a>
            </h2>
        `;

        const transcriptLink = `
            <a data-action="media#toggleTranscript" class="media-js-transcript-link" href="#media-${item.id}-transcript">Show transcript <span class="sr-only">for ${item.title}</span></a>
        `;

        const duration = `
            <span id="media-${item.id}-duration" class="media-js-duration" aria-label="${item.durationFull}">${item.durationCompact}</span>
        `;

        const transcript = `
            <div class="media-js-transcript-wrap">
                <blockquote id="media-${item.id}-transcript" class="media-js-transcript hidden">
                    <span class="sr-only">[Start of transcript]</span>
                    ${item.transcript}
                    <span class="sr-only">[End of transcript]</span>
                </blockquote>
            </div>
        `;

        return `
            <div class="md:flex">
                ${title}
                <div class="media-js-info">
                    <div class="media-js-transcript-link-wrap">
                        ${item.transcript ? transcriptLink : ''}
                    </div>
                    ${duration}
                </div>
            </div>
            ${item.transcript ? transcript : ''}
        `;
    }
}
